import { useState, useEffect } from "react";
import { X, Star, Play, Move, Sparkles, ArrowRight } from "lucide-react";
import { useStore, updateSettings } from "@/lib/store";
import { useAuth } from "@/lib/auth";

const STEPS = [
  {
    icon: <Sparkles size={22} strokeWidth={1.5} className="text-[#8FA087]" />,
    title: "Benvenuta in Tempo leggero",
    text: "Un piccolo giro veloce per farti sentire a casa. Ci vogliono 20 secondi."
  },
  {
    icon: <Star size={22} strokeWidth={1.5} className="text-[#D4A94A]" />,
    title: "Le tue tre priorità",
    text: "Tocca la stella su un'attività per aggiungerla alle priorità del giorno. Puoi sceglierne al massimo 3 — è il tuo filtro contro il fare tutto."
  },
  {
    icon: <Play size={22} strokeWidth={1.5} className="text-[#8FA087]" />,
    title: "Cronometro integrato",
    text: "Premi il tasto di avvio accanto a un'attività per far partire il cronometro. In alto vedrai la barra 'In corso' e sotto l'attività quanto tempo hai davvero speso."
  },
  {
    icon: <Move size={22} strokeWidth={1.5} className="text-[#8FA087]" />,
    title: "Trascina e sposta",
    text: "Trascina un'attività in Mattina/Pomeriggio/Sera e l'orario si sistema da solo. Nel settimanale trascina il bordo del blocco per allungarne la durata."
  }
];

export default function Onboarding() {
  const settings = useStore((s) => s.settings);
  const { user } = useAuth();
  const [i, setI] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (settings.onboarded) return;
    // Small delay so first render is settled
    const t = setTimeout(() => setOpen(true), 500);
    return () => clearTimeout(t);
  }, [settings.onboarded]);

  if (!open) return null;
  const step = STEPS[i];
  const last = i === STEPS.length - 1;

  function next() {
    if (last) {
      updateSettings({ onboarded: true });
      setOpen(false);
    } else {
      setI(i + 1);
    }
  }
  function skip() {
    updateSettings({ onboarded: true });
    setOpen(false);
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="onboarding-modal">
      <div className="absolute inset-0 bg-[#3B443D]/40" onClick={skip} />
      <div className="relative w-full max-w-md bg-white rounded-2xl border border-[#E4E7E1] shadow-xl p-8">
        <button onClick={skip} className="absolute top-4 right-4 text-[#6A7368] hover:text-[#3B443D]" data-testid="onboarding-close">
          <X size={18} strokeWidth={1.5} />
        </button>
        <div className="w-14 h-14 rounded-full bg-[#F3F5F0] flex items-center justify-center">{step.icon}</div>
        <h3 className="mt-4 font-serif-display font-semibold text-2xl text-[#3B443D]">{step.title}</h3>
        <p className="mt-2 text-sm text-[#58635B] leading-relaxed">{step.text}</p>
        <div className="mt-6 flex items-center justify-between">
          <div className="flex gap-1.5">
            {STEPS.map((s, idx) => (
              <span key={s.title} className={`w-1.5 h-1.5 rounded-full ${idx === i ? "bg-[#8FA087]" : "bg-[#E4E7E1]"}`} />
            ))}
          </div>
          <div className="flex items-center gap-2">
            <button onClick={skip} className="text-xs text-[#6A7368] hover:underline" data-testid="onboarding-skip">Salta</button>
            <button
              onClick={next}
              className="tl-btn-primary inline-flex items-center gap-1.5 px-5 py-2 rounded-full bg-[#A3B897] hover:bg-[#8FA087] text-white text-sm transition-all"
              data-testid="onboarding-next"
            >
              {last ? "Iniziamo" : "Avanti"}
              <ArrowRight size={14} strokeWidth={1.75} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
